import { ApiOptionList, ApiResponse } from "types/api.types";
import axiosClient from "utils/axios";
import type { RbacCatalogData } from "features/RolesAndPermissions/types/rbac-catalog.types";

export const getSectorOptions = async ({
  query,
  limit,
  page,
}: {
  query?: string;
  limit?: number;
  page?: number;
}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
      `/meta/sectors/options`,
      { params: { query, limit, page } },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching Sector Options : ", err);
    throw err;
  }
};

export const getModeOfPaymentOptions = async ({
  query,
  limit,
  page,
}: {
  query?: string;
  limit?: number;
  page?: number;
}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
      `/meta/mode-of-payments/options`,
      {
        params: {
          query,
          limit,
          page,
        },
      },
    );

    return response.data;
  } catch (err) {
    console.warn("Error fetching Mode Of Payment Options : ", err);
    throw err;
  }
};

export const getUomOptions = async ({
  query,
  limit,
  page,
}: {
  query?: string;
  limit?: number;
  page?: number;
}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
      `/meta/uoms/options`,
      {
        params: {
          query,
          limit,
          page,
        },
      },
    );

    return response.data;
  } catch (err) {
    console.warn("Error fetching Unit Of Measure Options : ", err);
    throw err;
  }
};

export const getProductTypeOptions = async ({
  query,
  limit,
  page,
}: {
  query?: string;
  limit?: number;
  page?: number;
}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
      `/meta/product-types/options`,
      {
        params: {
          query,
          limit,
          page,
        },
      },
    );

    return response.data;
  } catch (err) {
    console.warn("Error fetching product type Options : ", err);
    throw err;
  }
};

/**
 * GET /materials/options — catalog materials for AsyncPaginatedSelect (e.g. product form).
 * Same response shape as other meta option lists (`rows`, `hasMore`).
 */
export const getMaterialOptions = async ({
  query,
  limit = 50,
  page,
}: {
  query?: string;
  limit?: number;
  page?: number;
}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
      "/materials/options",
      {
        params: {
          query,
          limit,
          page,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching material options: ", err);
    throw err;
  }
};

export { getProductCategoryOptions } from "features/ProductCategories/services/ProductCategoryService";

export const getPriorityOptions = async ({
  query,
  limit,
  page,
}: {
  query?: string;
  limit?: number;
  page?: number;
}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
      `/meta/priorities/options`,
      {
        params: {
          query,
          limit,
          page,
        },
      },
    );

    return response.data;
  } catch (err) {
    console.warn("Error fetching Priority Options : ", err);
    throw err;
  }
};

export const getSkillOptions = async ({
  query,
  limit,
  page,
}: {
  query?: string;
  limit?: number;
  page?: number;
}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
      `/meta/skills/options`,
      {
        params: {
          query,
          limit,
          page,
        },
      },
    );

    return response.data;
  } catch (err) {
    console.warn("Error fetching Skill Options : ", err);
    throw err;
  }
};

export const getSourceChannelOptions = async ({
  query,
  limit,
  page,
}: {
  query?: string;
  limit?: number;
  page?: number;
}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
      `/meta/source-channels/options`,
      {
        params: {
          query,
          limit,
          page,
        },
      },
    );

    return response.data;
  } catch (err) {
    console.warn("Error fetching source channel options : ", err);
    throw err;
  }
};

export const getRbacCatalog = async () => {
  try {
    const response =
      await axiosClient.get<ApiResponse<RbacCatalogData>>(`/meta/rbac-catalog`);
    return response.data;
  } catch (err) {
    console.warn("Error fetching RBAC catalog: ", err);
    throw err;
  }
};
